module.exports = __webpack_public_path__ + "assets/img/about-us-small.37b0149d.jpg";